import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Opportunity} from '../../opportunity/opportunity';
import {OpportunityService} from '../../services/opportunity-service';
import {SelectionItem} from '../../selections/selection-item';
import {SelectionService} from '../../services/selection-service';
import {DateUtils} from '../../utils/date-utils';
import {MatButton} from '@angular/material/button';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatInput} from '@angular/material/input';
import {MatOption} from '@angular/material/core';

import {FormsModule} from '@angular/forms';
import {MatSelect} from '@angular/material/select';
import {MatFormField, MatHint, MatSuffix} from '@angular/material/form-field';

@Component({
    selector: 'app-require-opp-updates-dialog',
    templateUrl: './require-opp-updates-dialog.component.html',
    styleUrls: ['./require-opp-updates-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatSelect, FormsModule, MatOption, MatHint, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton]
})
export class RequireOpportunityUpdatesDialogComponent implements OnInit {
  private readonly opportunityService = inject(OpportunityService);
  private readonly selectionService = inject(SelectionService);
  private readonly dialogRef = inject<MatDialogRef<RequireOpportunityUpdatesDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);

  opportunity: Opportunity;
  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  readonly statuses = signal<SelectionItem[]>([]);
  readonly phases = signal<SelectionItem[]>([]);
  readonly hasStatus = signal<boolean>(undefined!);
  readonly hasPhase = signal<boolean>(undefined!);

  constructor() {
    this.opportunity = this.data.opportunity}

  ngOnInit(): void {
    this.selectionService.getOpportunityStatusCodes().subscribe(
      status => {
        this.statuses.set(status);
        this.hasStatus.set(!!this.statuses().find(item => item.code === this.opportunity.statusCode));
      });
    this.selectionService.getOpportunityPhaseCodes().subscribe(
      phase => {
        this.phases.set(phase);
        this.hasPhase.set(!!this.phases().find(item => item.code === this.opportunity.currentPhaseCode));
      });
  }

  update(): void {
    this.isBusy.set(true);
    this.errorMessage.set("");
    this.opportunityService.save(this.opportunity).subscribe({
      next: () => {
        this.isBusy.set(false);
        this.dialogRef.close();
      },
      error: error => this.errorMessage.set(error.message)
    });
  }

  dateStartValue(): Date {
    return new Date(this.opportunity.expectedFirstShipmentDate);
  }

  public setExpectedFirstShipmentDate(newValue: Date) {
    this.opportunity.expectedFirstShipmentDate = DateUtils.formatOutput(newValue);
  }

  public formatDisplayDate(input: Date): Date {
    return DateUtils.formatDisplay(input);
  }

  updateHasFields(): void {
    this.hasStatus.set(!!this.statuses().find(item => item.code === this.opportunity.statusCode));
    this.hasPhase.set(!!this.phases().find(item => item.code === this.opportunity.currentPhaseCode));
  }

  public isValid(): boolean {
    return this.hasPhase() && this.hasStatus();
  }

}
